const siteUrl = 'https://www.ourismancars.com/'

module.exports = {
  /* Your site config here */
  siteMetadata: {
    title: 'Findlay',
    siteUrl:'https://www.ourismancars.com/',
    site_id: '670d82edf3725edbc2b59f9e',
    api_base_url: 'https://api.dealermasters.com:4500',
    lead_url: 'https://leads.dealermasters.com/leads',
    distance_history: 'https://aalnfl2zj7.execute-api.us-east-2.amazonaws.com/Prod', //Distance history API Gateway AWS
    googleAPIkey: 'AIzaSyCddq6ehnmTvcAdFOvG5xEGhn8jZV3eBqY',
    quickgenAPI: 'https://dev.mxsapi.com',
    imageBaseURL: 'https://images.mxssolutions.com', //PROD: 'https://images.mxssolutions.com'
    opensearchAPI: 'https://tehy4uupcb.execute-api.us-east-2.amazonaws.com/opensearch-inventory-search-api/'// DEV: 'https://q0mj4jv9i6.execute-api.us-east-2.amazonaws.com/opensearch-inventory-search-api/'
  },
  plugins: [
    'gatsby-plugin-react-helmet',
    {
      resolve: "gatsby-plugin-force-trailing-slashes"
    },
    {
      resolve: 'gatsby-plugin-advanced-sitemap',
      options: {
      },
    },
    {
      resolve: "gatsby-plugin-emotion"
    },
    {
      resolve: "gatsby-transformer-json"
    },
    {
      resolve: "gatsby-plugin-sass",
      options: {
        cssLoaderOptions: {
          camelCase: false,
        },
      },
    },
    {
      resolve: "gatsby-plugin-react-svg",
      options: {
        rule: {
          include: /\.inline\.svg$/
        }
      }
    },
    {
      resolve: `gatsby-source-filesystem`,
      options: {
        name: `src`,
        path: `${__dirname}/src/`
      }
    },
    {
      resolve: 'gatsby-plugin-s3',
      options: {
        bucketName: 'mxs-32fc8386-7dda-4d4c-8f1b-638ad242bf21-prodsite'
      }
    },
    `gatsby-transformer-json`,
    {
      resolve: require.resolve('./plugins/gatsby-source-dynamodb-query'),
      options: {
        typeName: 'inventory',
        region: 'us-east-2',
        tableName: 'AdjustedInventory',
        dealerId: ['62610','45281','64285','102006','62030','62496','208202','183531','49341','2315449','231545','231548','495249','197213','62196','231549','606739','2236239']//126024
      }
    },
    {
      resolve: 'gatsby-plugin-manifest',
      options: {
        icon: 'static/favicon.png'
      }
    },{
      resolve: 'gatsby-plugin-robots-txt',
      options: {
        host: 'https://www.ourismancars.com/',
        sitemap: 'https://www.ourismancars.com/sitemap-pages.xml',
        policy: [{ userAgent: '*', allow: '/' }]
      }
    }
  ]
}